import { isPrivateKey, isTerminateValue } from '../helper'
import {
  getPrototypeOf,
  isArray,
  keys,
  mapPrototype,
  objectPrototype,
  setPrototype
} from '../shortcut'

import type { TArray, TRecord, TWeakMap } from '../types'

export function clone<T = any>(value?: T): T {
  return internalClone(value, new WeakMap())
}

function internalClone(value: any, seen: TWeakMap): any {
  if (isTerminateValue(value)) return value
  if (seen.has(value)) return seen.get(value)
  if (typeof value.toJS === 'function') return value.toJS()
  if (typeof value.toJSON === 'function') return value.toJSON()
  if (isArray(value)) {
    const array: TArray = []
    seen.set(value, array)
    for (const val of value) array.push(internalClone(val, seen))
    return array
  }
  let prototype
  if ((prototype = getPrototypeOf(value)) === objectPrototype) {
    const object: TRecord = {}
    seen.set(value, object)
    for (const key of keys(value)) {
      if (isPrivateKey(key)) continue
      object[key] = internalClone(value[key], seen)
    }
    return object
  }
  if (prototype === mapPrototype) {
    const map = new Map()
    seen.set(value, map)
    value.forEach((value: any, key: any) => {
      map.set(key, internalClone(value, seen))
    })
    return map
  }
  if (prototype === setPrototype) {
    const set = new Set()
    seen.set(value, set)
    value.forEach((value: any) => {
      set.add(internalClone(value, seen))
    })
    return set
  }
  return value
}
